import { onSignalREvent } from '../../signalRBus'
import { SIGNAL_R_MESSAGES, SIGNAL_R_SCOPES } from 'src/signalR/types'
import type { MessageReadSignalRPayload } from 'src/signalR/types'
import { useMessagingServiceStore } from 'src/stores/messaging.service.store'
import { useAuthStore } from 'src/common/store'

onSignalREvent(
  SIGNAL_R_SCOPES.message,
  SIGNAL_R_MESSAGES.messageRead,
  (text, response) => {
    const payload: MessageReadSignalRPayload = JSON.parse(text)
    const messagingServiceStore = useMessagingServiceStore()
    // Only process if same center (or no center info available)
    const authStore = useAuthStore()
    if (
      response.CenterId &&
      response.CenterId !== authStore.currentCenterId &&
      !authStore.isClient
    ) {
      return
    }
    messagingServiceStore.handleMessageReadEvent(payload)
  },
)
